import * as React from "react";
import ImportExcel from "../UI/ImportExcel";

const InputetTableImportExcel = ({
  isOpen = false,
  onClose,
  name,
  formData,
  formId,
  maxOrder,
  onSubmitData,
}) => {
  const onSubmit = (data) => {
    const dataValid = {
      id: formId,
      lines: transformData(data?.validData, maxOrder + 1),
    };
    onSubmitData(dataValid);
  };

  const transformData = (data, minOrder) => {
    return data.map((item) => ({
      answers: Object.entries(item).map(([formInputId, answer]) => ({
        formInputId,
        answer: convertInputValueForInsert(answer), // Konverton në numër nëse është numerik
      })),
      order: minOrder++,
    }));
  };

  // Funksioni që konverton vlerën në numër ose datë nëse është e mundur
  const fields = formData?.map(({ id, label, type, properties }) => ({
    label: label,
    key: id,
    example: label,
    fieldType: {
      // There are 3 types - "input" / "checkbox" / "select".
      type: type === "SELECT" ? "select" : "input",
      options: properties.options.map((item) => ({
        label: item.key,
        value: item.value,
      })),
    },
  }));

  const fieldsExample = [
    {
      label: "perdoruesi",
      key: "username",
      example: "username",
      fieldType: {
        // There are 3 types - "input" / "checkbox" / "select".
        type: "input",
      },
    },
    {
      label: "emri",
      key: "firstName",
      example: "Emri",
      fieldType: {
        // There are 3 types - "input" / "checkbox" / "select".
        type: "input",
      },
    },

    {
      label: "mbiemri",
      key: "lastName",
      example: "Mbiemri",
      fieldType: {
        // There are 3 types - "input" / "checkbox" / "select".
        type: "input",
      },
    },
    {
      label: "Bashkia",
      key: "bashkia",
      example: "Tirane",
      fieldType: {
        // There are 3 types - "input" / "checkbox" / "select".
        type: "select",
        options: [
          { label: "Tirana", value: "12345" },
          { label: "Durres", value: "23456" },
        ],
      },
    },
  ];

  return (
    <ImportExcel
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={onSubmit}
      fields={fields}
      title={name}
    />
  );
};

// export const convertInputValueForInsert = (value) => {
//   if (typeof value !== "string") return value; // Nëse nuk është string, ktheje siç është

//   // Kontrollo nëse është numër
//   if (!isNaN(value) && value.trim() !== "") {
//     return Number(value);
//   }

//   // Kontrollo nëse është datë me format "dd-mm-yyyy" ose "yyyy-mm-dd"
//   const ddmmyyyyRegex = /^\d{2}-\d{2}-\d{4}$/; // dd-mm-yyyy
//   const yyyymmddRegex = /^\d{4}-\d{2}-\d{2}$/; // yyyy-mm-dd

//   if (ddmmyyyyRegex.test(value)) {
//     // Ndaje pjesët e datës dhe ri-formatizo në "yyyy-mm-dd"
//     const [day, month, year] = value.split("-");
//     return `${year}-${month}-${day}`;
//   }

//   if (yyyymmddRegex.test(value)) {
//     return value; // Nëse tashmë është në formatin e duhur, mos e ndrysho
//   }

//   return value; // Kthe vlerën origjinale nëse nuk është një nga datat e synuara
// };

export const convertInputValueForInsert = (
  value,
  outputFormat = "yyyy-mm-dd"
) => {
  // Nëse vlera është një objekt Date, konvertoje në string në formatin e kërkuar
  if (
    Object.prototype.toString.call(value) === "[object Date]" &&
    !isNaN(value)
  ) {
    const day = String(value.getDate()).padStart(2, "0");
    const month = String(value.getMonth() + 1).padStart(2, "0"); // Muajt fillojnë nga 0
    const year = value.getFullYear();

    return outputFormat === "yyyy-mm-dd"
      ? `${year}-${month}-${day}`
      : `${day}-${month}-${year}`;
  }

  if (typeof value !== "string") return value; // Nëse nuk është string dhe nuk është Date, ktheje siç është

  // Kontrollo nëse është numër
  if (!isNaN(value) && value.trim() !== "") {
    return Number(value);
  }

  // Kontrollo nëse është një nga formatet e njohura të datës
  const dateRegex = [
    /^(\d{2})-(\d{2})-(\d{4})$/, // dd-mm-yyyy
    /^(\d{4})-(\d{2})-(\d{2})$/, // yyyy-mm-dd
    /^(\d{2})\/(\d{2})\/(\d{4})$/, // dd/mm/yyyy
    /^(\d{4})\/(\d{2})\/(\d{2})$/, // yyyy/mm/dd
    /^(\d{2})\.(\d{2})\.(\d{4})$/, // dd.mm.yyyy
  ];

  for (const regex of dateRegex) {
    const match = value.match(regex);
    if (match) {
      let year, month, day;

      if (regex === dateRegex[0]) [day, month, year] = match.slice(1); // dd-mm-yyyy
      if (regex === dateRegex[1]) [year, month, day] = match.slice(1); // yyyy-mm-dd
      if (regex === dateRegex[2]) [day, month, year] = match.slice(1); // dd/mm/yyyy
      if (regex === dateRegex[3]) [year, month, day] = match.slice(1); // yyyy/mm/dd
      if (regex === dateRegex[4]) [day, month, year] = match.slice(1); // dd.mm.yyyy

      // Siguro që dita dhe muaji janë dyshifrorë (p.sh. 05 jo 5)
      day = day.padStart(2, "0");
      month = month.padStart(2, "0");

      // Rikthe në formatin e dëshiruar si string
      return outputFormat === "yyyy-mm-dd"
        ? `${year}-${month}-${day}`
        : `${day}-${month}-${year}`;
    }
  }

  return value; // Kthe vlerën origjinale nëse nuk është një datë e njohur
};

export default InputetTableImportExcel;
